module.exports = __webpack_public_path__ + "static/media/inclusion_room_limit.192e83b1.svg";